(function () {
    'use strict';

    angular
        .module('portalApp')
        .provider('chartConfig', chartConfig);

    // configuration
    chartConfig.$inject = ['chartConstants'];
    function chartConfig(chartConstants) {
        this.scenarioChartDefaultDateFormat = 'YYFP';
        this.scenarioChartDefaultFrequency = 4; //quarterly
        this.scenarioChartDefaultShadowStyle = {
            color: '#e1c1ee',
            opacity: 0.25
        };
        this.scenarioChartDefaultObject = {
            height: 500,
            title: {
                //Title text is to be filled in the app
                text: '',
                font: {
                    fontFamily: "Helvetica",
                    fontWeight: 'lighter',
                    color: "#560939",
                    size: '16px'
                }
            },
            xAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#777"
                },
                show: true, // to be changed for empty charts
                grid: true,
                scale: 'category',
                labelOverlap: 'wrap', // labels that do not fit go to a second row
                shading: [] //range shadowing is empty by default
            },
            yAxis: {
                font: {
                    size: "13px",
                    fontFamily: "Helvetica",
                    color: "#777"
                },
                title: {
                    show: false,
                    text: '',
                    font: {
                        size: "13px",
                        fontFamily: "Helvetica",
                        color: "#777"
                    }
                },
                show: true, // to be changed for empty charts
                grid: true
            },
            seriesStyle: {
                defaultOpacity: 0.75,
                hoverOpacity: 1
            },
            // lines are drawn in from the left when the chart appears
            animate: true,
            //Series are to be filled in the app
            series: [],
            //vertical tracker line with a tooltip per series
            tracker: true,
            legend: {
                show: false
            },
            placeholder: {
                show: false, // to be changed for empty charts
                text: "Empty",
                fontSize: "24px",
                opacity: 0.2
            },
            tooltipText: tooltipText
        };

        this.scenarioChartDefaultLineStyles = {
            predefined: [ //todo: only six lines are predefined so far, will see if more is needed
                {
                    width: 3,
                    color: chartConstants.lineColorSet[0],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[1],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[2],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[3],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[4],
                    dashSetting: [1, 0],
                    markerSize: 2
                },
                {
                    width: 3,
                    color: chartConstants.lineColorSet[5],
                    dashSetting: [1, 0],
                    markerSize: 2
                }
            ],
            new: {
                width: 3,
                color: null, //will be picked automatically
                dashSetting: [1, 0],
                markerSize: 0
            }
        };

        this.$get = function () {
            return {
                scenarioChartDefaults: {
                    chartObject: this.scenarioChartDefaultObject,
                    lineStyles: this.scenarioChartDefaultLineStyles,
                    dateFormat: this.scenarioChartDefaultDateFormat,
                    frequency: this.scenarioChartDefaultFrequency,
                    shadowStyle: this.scenarioChartDefaultShadowStyle
                }
            };
        };

        function tooltipText(point) {
            //reformat Y number up to 4th precision point
            return point.x + " : " + point.y.toPrecision(4);
        }
    }
})();
